import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationPage from "src/components/StatusBackground/ConfirmationPage";
import MarkdownWithRouter from "src/components/MarkdownWithRouter";

const RequestPassword = () => {
  const { t } = useTranslation();
  return (
    <ConfirmationPage title={t("requestPassword.title")} icon="svg/Check.svg">
      <h4>{t("requestPassword.thankYouTitle")}</h4>
      <h4>{t("requestPassword.whatsNextTitle")}</h4>
      <p>{t("requestPassword.emailInstructions")}</p>
      <p>{t("requestPassword.checkJunk")}</p>
      <p>
        <strong>
          <MarkdownWithRouter>{t("requestPassword.contactSupport")}</MarkdownWithRouter>
        </strong>
      </p>
    </ConfirmationPage>
  );
};

export default RequestPassword;
